import { REGIONS, ENVS } from '@adsk/bim360-matrix-react-helpers/es/consts';

export const ENV_CONFIG_KEYS = {
  NOTIFICATIONS_SERVICE: 'NOTIFICATIONS_SERVICE',
  RELATIONSHIP_SERVICE: 'RELATIONSHIP_SERVICE',
  DOCS: 'DOCS',
  LAUNCH_DARKLY_API_KEY: 'LAUNCH_DARKLY_API_KEY'
};

const APIGEE_HOST = {
  [ENVS.DEV]: 'https://developer-stg.api.autodesk.com',
  [ENVS.QA]: 'https://developer-stg.api.autodesk.com',
  [ENVS.STAGING]: 'https://developer-stg.api.autodesk.com',
  [ENVS.PROD]: 'https://developer.api.autodesk.com'
};

const US_CONFIG = {
  [ENVS.DEV]: {
    [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360-dev.autodesk.com',
    [ENV_CONFIG_KEYS.NOTIFICATIONS_SERVICE]: `${APIGEE_HOST[ENVS.DEV]}/bim360/notifications-dev/v1`,
    [ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE]: `${APIGEE_HOST[ENVS.DEV]}/bim360/relationship-dev/v2`,
    [ENV_CONFIG_KEYS.LAUNCH_DARKLY_API_KEY]: '5ce250221e7d2a082181d696'
  },
  [ENVS.QA]: {
    [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360-qa.autodesk.com',
    [ENV_CONFIG_KEYS.NOTIFICATIONS_SERVICE]: `${APIGEE_HOST[ENVS.QA]}/bim360/notifications-qa/v1`,
    [ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE]: `${APIGEE_HOST[ENVS.QA]}/bim360/relationship-dev/v2`,
    [ENV_CONFIG_KEYS.LAUNCH_DARKLY_API_KEY]: '5ce25022492e27082cb98edd'
  },
  [ENVS.STAGING]: {
    [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360-staging.autodesk.com',
    [ENV_CONFIG_KEYS.NOTIFICATIONS_SERVICE]: `${APIGEE_HOST[ENVS.STAGING]}/bim360/notifications/v1`,
    [ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE]: `${APIGEE_HOST[ENVS.STAGING]}/bim360/relationship/v2`,
    [ENV_CONFIG_KEYS.LAUNCH_DARKLY_API_KEY]: '5ce2502156788608227a8d49'
  },
  [ENVS.PROD]: {
    [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360.autodesk.com',
    [ENV_CONFIG_KEYS.NOTIFICATIONS_SERVICE]: `${APIGEE_HOST[ENVS.PROD]}/bim360/notifications/v1`,
    [ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE]: `${APIGEE_HOST[ENVS.PROD]}/bim360/relationship/v2`,
    [ENV_CONFIG_KEYS.LAUNCH_DARKLY_API_KEY]: '5ce25021492e27082cb98ed9'
  }
};

export const ENV_CONFIGS = {
  [REGIONS.US]: US_CONFIG,
  [REGIONS.EMEA]: {
    [ENVS.DEV]: US_CONFIG[ENVS.DEV],
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      ...US_CONFIG[ENVS.STAGING],
      [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360-staging.eu.autodesk.com'
    },
    [ENVS.PROD]: {
      ...US_CONFIG[ENVS.PROD],
      [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360.eu.autodesk.com'
    }
  },
  [REGIONS.FEDRAMP]: {
    [ENVS.DEV]: US_CONFIG[ENVS.DEV],
    [ENVS.QA]: US_CONFIG[ENVS.QA],
    [ENVS.STAGING]: {
      ...US_CONFIG[ENVS.STAGING],
      [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360-staging.afg.us.autodesk.com'
    },
    [ENVS.PROD]: {
      ...US_CONFIG[ENVS.PROD],
      [ENV_CONFIG_KEYS.DOCS]: 'https://docs.b360.afg.us.autodesk.com'
    }
  }
};
